import { createAuthClient } from "better-auth/react";
import { jwtClient } from "better-auth/client/plugins";

const AUTH_URL =
  process.env.REACT_APP_AUTH_URL ??
  (process.env.NODE_ENV === "production"
    ? "https://auth.bikendure.com"
    : "http://localhost:3001");

export const authClient = createAuthClient({
  baseURL: AUTH_URL,
  plugins: [jwtClient()],
});

export type Session = typeof authClient.$Infer.Session;
export type User = typeof authClient.$Infer.Session.user;
